const Accounts = {
  ACCOUNT_UPDATE_EMAIL: 'account/update_email',
  ACCOUNT_UPDATE_PROFILE: 'account/update_profile',
}

export default Accounts;